import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

export function Success({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={twMerge("rounded-md border border-success/50 bg-success/35 p-4 font-disinterest", className)}>
      {children}
    </div>
  );
}
